import React, { useState } from "react";
import { Calendar } from "lucide-react";
import { Card } from "../ui/card";
import { useFm, fmtKg, Seg, Bars, SourceNote } from "./biShared";

const GLABEL = { day: "giorno", week: "settimana", month: "mese" };

export default function BiTrend({ data }) {
  const fm = useFm();
  const [metric, setMetric] = useState("revenue");
  const t = data.trend;
  return (
    <Card className="bg-white border-stone-200 p-4" data-testid="bi-trend">
      <div className="flex items-center justify-between gap-2 mb-3 flex-wrap">
        <h3 className="font-semibold text-stone-900 flex items-center gap-2"><Calendar className="w-4 h-4 text-[#8A1C2A]" /> Andamento per {GLABEL[t.granularity]} <span className="text-xs font-normal text-stone-500">{t.buckets.length} periodi</span></h3>
        <div className="flex items-center gap-1">
          <Seg size="sm" options={[{ value: "revenue", label: "Fatturato" }, { value: "kg", label: "Kg" }, { value: "ddt_count", label: "N. DDT" }]} value={metric} onChange={setMetric} testIdPrefix="bi-trend-metric" />
          <SourceNote text={data.notes.trend} testId="bi-trend-source" />
        </div>
      </div>
      <div className="max-h-[420px] overflow-y-auto pr-1">
        <Bars data={t.buckets} valueKey={metric} formatValue={(v) => (metric === "revenue" ? fm(v) : metric === "kg" ? `${fmtKg(v, 0)} kg` : `${v} DDT`)} color={metric === "kg" ? "#B45309" : metric === "ddt_count" ? "#1D4ED8" : "#8A1C2A"} testIdPrefix="bi-trend-bar" />
      </div>
    </Card>
  );
}
